import React, { useState, useEffect, useRef, useContext } from 'react';
import {
  Menu,
  Tab,
  Grid,
  Button,
  Input,
  Icon,
  Popup,
  Checkbox,
  List,
  Header,
  Divider,
  Modal,
  Form,
  Segment,
  Item,
  Confirm,
  Progress,
  Dimmer,
} from 'semantic-ui-react';
import Draggable from '../DnD/Draggable';
import { useSelector, useDispatch } from 'react-redux';
import { resourceActions, templateActions, designActions } from '../../actions';
import Gallery from 'react-photo-gallery';
import InfiniteScroller from 'react-infinite-scroller';
import { calculateDroppedEntitySize, generateImageLink } from '../../utils/design.utils';
import HorizontalCards from '../HorizontalCards/HorizontalCards';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import TabPane from './TabPane';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { ReactSVG } from 'react-svg';
import * as Yup from 'yup';
import * as icons from '../../assets/images/GBTools/_toolsIcon';
import { ReactComponent as SvgCloseSlid } from '../../assets/images/GBTools/closeSlid.svg';
import { isMobileOnly } from 'react-device-detect';
import { toast } from 'react-toastify';
import { browserName } from 'react-device-detect';
import { useParams } from 'react-router-dom';
import SlideShow from '../SlideShow/SlideShow';
import { templateService } from '../../services';
import './VSidebar.css';

const Tools = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { _type, _designId, _tempId } = useParams();
  const { activePageRef } = useContext(DesignContext);
  const [hideMenu, setHideMenu] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [uploadTabActiveIndex, setUploadTabActiveIndex] = useState(0);
  const [openCreateFolder, setOpenCreateFolder] = useState(false);
  const [panes, setPanes] = useState();
  const [openFolders, setOpenFolders] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [activeDim, setActiveDim] = useState(false);
  const [showTemplatePages, setShowTemplatePages] = useState(false);
  const [tutorialVideoTemplate, setTutorialVideoTemplate] = useState(null);
  const [lessonTemplate, setLessonTemplate] = useState(null);
  const [lessonResources, setLessonResources] = useState([]);
  const [lessonResourcesLoading, setLessonResourcesLoading] = useState(false);
  const user = useSelector(state => state.authentication.user);
  const isOperationalUser = ['operator', 'admin'].includes(user.role);
  const hasSubscription = useSelector(state => state.subscription.hasSubscription);
  const templateStatus = useSelector(state => state.template.status);
  const templates = useSelector(state => state.template.templates);
  const selectedTemplateCategory = useSelector(state => state.design.selectedCategory);
  const hasMoreTemplate = useSelector(state => state.template.hasMoreTemplate);
  const userImages = useSelector(state => state.resource.userImages);
  const hasMoreUserImage = useSelector(state => state.resource.hasMoreUserImage);
  const userVideos = useSelector(state => state.resource.userVideos);
  const hasMoreUserVideo = useSelector(state => state.resource.hasMoreUserVideo);
  const userFolders = useSelector(state => state.resource.userFolders);
  const designLoaded = useSelector(state => state.design.designLoaded);
  const designHeight = useSelector(state => state.design.height);
  const designWidth = useSelector(state => state.design.width);
  const sourceTemplateId = useSelector(state => state.design.sourceTemplateId);
  const selectedTemplateId = useSelector(state => state.template.templateId);
  const replaceEntity = useSelector(state => state.design.replaceEntity);
  const selectedEntity = useSelector(state => state.design.selectedEntity);
  const folderState = useSelector(state => state.resource.folderState);
  const uploading = useSelector(state => state.resource.uploading);
  const uploadProgress = useSelector(state => state.resource.uploadProgress);
  const tempId = useRef();
  const uploadPanes = useRef();
  const fileInputRef = useRef();
  const initResources = useRef([true, true, true, true, true, true, true]);
  const userImageList = useRef([]);
  const userVideoList = useRef([]);
  const userImageScrollPaneRef = useRef();
  const userVideoScrollPaneRef = useRef();
  const templateScrollPaneRef = useRef();
  const designHeightRef = useRef();
  const designWidthRef = useRef();
  const templateInputRef = useRef();
  const closeIconRef = useRef();
  const returnButtonRef = useRef();
  const userFoldersRef = useRef([]);
  const userFoldersMenu = useRef([]);
  const openFolderRef = useRef();
  const selectedFolderRef = useRef();
  const selectedTemplateRef = useRef();
  const templatePagesRef = useRef();
  // const init = useRef(true);
  const authToken = useSelector(state => state.authentication.user.authToken);
  const CreateFolderSchema = Yup.object().shape({
    name: Yup.string().required(t('yupPasswordReq')),
  });
  const formikCreateFolder = useFormik({
    initialValues: {
      name: '',
    },
    validationSchema: CreateFolderSchema,
    onSubmit: (values, { resetForm }) => {
      dispatch(resourceActions.createFolder(values.name));
      resetForm();
    },
    onReset: () => {
      setOpenCreateFolder(false);
    },
  });

  const notify = message => toast.success(message);

  const lessonTemplateId = sourceTemplateId || (_type === 'template' ? _designId : selectedTemplateId);

  useEffect(() => {
    let active = true;
    if (!lessonTemplateId) {
      setLessonTemplate(null);
      setLessonResources([]);
      return undefined;
    }

    setLessonResourcesLoading(true);
    Promise.all([
      templateService.findOne(lessonTemplateId),
      templateService.getResources(lessonTemplateId),
    ]).then(([template, resources]) => {
      if (!active) return;
      setLessonTemplate(template);
      setLessonResources(Array.isArray(resources) ? resources : []);
    }).catch(() => {
      if (!active) return;
      setLessonTemplate(null);
      setLessonResources([]);
    }).finally(() => {
      if (active) setLessonResourcesLoading(false);
    });

    return () => { active = false; };
  }, [lessonTemplateId]);

  useEffect(() => {
    dispatch(templateActions.resetState());

    // Operator has been opened by link with templateId
    if (isOperationalUser && _designId) {
      dispatch(templateActions.selectTemplate(_designId));
      if (_tempId) {
        tempId.current = _tempId;
        loadMoreResource('Image', true);
        loadMoreResource('Element', true);
        loadMoreResource('Video', true);
        initResources.current[1] = false;
        initResources.current[2] = false;
      }
    }

    if (_type === 'text') loadMoreResource('Text', true);

    if (window.innerWidth < 650) {
      handleRangeChange();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (designLoaded && _type !== 'text') {
      loadMoreResource('Template', true);
      initResources.current[0] = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [designLoaded]);

  useEffect(() => {
    designWidthRef.current = designWidth;
    designHeightRef.current = designHeight;
  }, [designWidth, designHeight]);

  useEffect(() => {
    userImageList.current = [];
    if (userImages)
      userImages.forEach((image, index) => {
        const width = Number(image.width) > 0 ? Number(image.width) : 1;
        const height = Number(image.height) > 0 ? Number(image.height) : 1;
        userImageList.current.push({
          src: generateImageLink(`${process.env.REACT_APP_FILE_SERVER}/users/${user.userId}/resources/${image.name}/thumbnail.${image.extension}`, authToken),
          width,
          height,
          key: index.toString(),
          type: image.type,
          data: {
            srcThumbnail: generateImageLink(`${process.env.REACT_APP_FILE_SERVER}/users/${user.userId}/resources/${image.name}/thumbnail.${image.extension}`, authToken),
            src: generateImageLink(`${process.env.REACT_APP_FILE_SERVER}/users/${user.userId}/resources/${image.name}/screen.${image.extension}`, authToken),
            id: image._id,
            alias: image.alias,
            width,
            height,
          },
        });
      });
  }, [user, userImages,authToken]);

  useEffect(() => {
    userVideoList.current = [];
    if (userVideos)
      userVideos.forEach((video, index) => {
        const width = Number(video.width) > 0 ? Number(video.width) : 1;
        const height = Number(video.height) > 0 ? Number(video.height) : 1;
        userVideoList.current.push({
          src: generateImageLink(`${process.env.REACT_APP_FILE_SERVER}/users/${user.userId}/resources/${video.name}/frame.${video.extension}`, authToken),
          width,
          height,
          key: index.toString(),
          type: 'Video',
          data: {
            srcThumbnail: generateImageLink(`${process.env.REACT_APP_FILE_SERVER}/users/${user.userId}/resources/${video.name}/thumbnail.${video.extension}`, authToken),
            src: generateImageLink(`${process.env.REACT_APP_FILE_SERVER}/users/${user.userId}/resources/${video.name}/screen.${video.extension}`, authToken),
            id: video._id,
            alias: video.alias,
            width,
            height,
          },
        });
      });
  }, [user, userVideos,authToken]);

  useEffect(() => {
    uploadPanes.current = [
      {
        menuItem: (
          <Menu.Item key="image">
            <div className="title">{t('pictures')}</div>
          </Menu.Item>
        ),
        pane: {
          key: 'image',
          content: (
            <div ref={userImageScrollPaneRef} className="scroller-pan">
              {customInfiniteScroller({
                hasMore: hasMoreUserImage,
                type: 'UserImage',
                photos: userImageList.current,
                scrollParentRef: userImageScrollPaneRef,
              })}
            </div>
          ),
        },
      },
      {
        menuItem: (
          <Menu.Item key="video">
            <div className="title">{t('videos')}</div>
          </Menu.Item>
        ),
        pane: {
          key: 'video',
          content: (
            <div ref={userVideoScrollPaneRef} className="scroller-pan">
              {customInfiniteScroller({
                hasMore: hasMoreUserVideo,
                type: 'UserVideo',
                photos: userVideoList.current,
                scrollParentRef: userVideoScrollPaneRef,
              })}
            </div>
          ),
        },
      },
    ];

    userFoldersRef.current = userFolders;
    userFoldersMenu.current = [];
    userFolders.forEach((folder, index) => {
      userFoldersMenu.current.push(
        <List.Item key={index} onClick={() => handleUserFolderClick(folder)}>
          <span className="item-image">
            <Icon name="folder" size="large" />
          </span>
          <List.Content>
            <List.Header>{folder.name === '__Liked__' ? t('liked') : folder.name}</List.Header>
          </List.Content>
        </List.Item>,
      );
    });

    const tempPanes = [
      {
        menuItem: replaceEntity ? null : (
          <Menu.Item key="template">
            <div className="icon">
              <ReactSVG src={icons.template} wrapper="span" />
            </div>
            <div className="title">{t('school')}</div>
          </Menu.Item>
        ),
        pane: (
          <Tab.Pane key="template">
            <Input
              name="Template"
              onChange={handleSearchChange}
              onKeyPress={handleSearchKeyPress}
              icon
              fluid
              className="searchBox"
              // size="large"
              placeholder={t('search')}
            >
              <Icon
                title="searchIcon"
                name="search"
                link
                style={{ right: 'auto', left: '1px' }}
                onClick={handleSearchKeyPress}
              />
              <input ref={templateInputRef} style={{ paddingLeft: '2.6em', paddingRight: '1em' }} />
              <i
                ref={closeIconRef}
                title="Template"
                aria-hidden="true"
                className="remove link icon"
                style={{ display: 'none' }}
                onClick={handleSearchClearClicked}
              />
            </Input>
            <Button
              title="Template"
              className="searchResetBtn"
              ref={returnButtonRef}
              onClick={handleSearchClearClicked}
              // style={{ display: 'none' }}
              content={t('goBack')}
            />
            {showTemplatePages ? (
              <div className="templatePage">
                <Icon name="angle right" onClick={() => setShowTemplatePages(false)} />
                <span>{_.get(templatePagesRef.current, '[0].name', '')}</span>
                <Button
                  className="useAllPagesBtn"
                  content={t('useAllPages')}
                  onClick={() => handleResourceClicked(selectedTemplateRef.current)}
                />
                <Gallery
                  photos={templatePagesRef.current || []}
                  targetRowHeight={100}
                  limitNodeSearch={undefined}
                  renderImage={args => customRenderImage(args, 'TemplatePage')}
                />
              </div>
            ) : (
              <div ref={templateScrollPaneRef} className="scroller-pan">
                {customInfiniteScroller({
                  hasMore: hasMoreTemplate,
                  type: 'Template',
                  photos: templates,
                  scrollParentRef: templateScrollPaneRef,
                  searchByTag: tag => {
                    templateScrollPaneRef.current.className = 'scroller-pan searched-content';
                    returnButtonRef.current.ref.current.className = 'searchResetBtn active';
                    closeIconRef.current.style.display = 'block';
                    templateInputRef.current.value = tag;
                    loadMoreResource('Template', true, {});
                  },
                  loading: templateStatus,
                })}
              </div>
            )}
          </Tab.Pane>
        ),
      },
      {
        menuItem: (
          <Menu.Item key="image">
            <div className="icon">
              <ReactSVG src={icons.image} wrapper="span" />
            </div>
            <div className="title">{t('picture')}</div>
          </Menu.Item>
        ),
        pane: (
          <Tab.Pane key="image">
            <TabPane
              type="Image"
              userId={user.userId}
              searchEnable={true}
              loadMoreResource={loadMoreResource}
              handleResourceClicked={handleResourceClicked}
              customInfiniteScroller={customInfiniteScroller}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: replaceEntity ? null : (
          <Menu.Item key="element">
            <div className="icon">
              <ReactSVG src={icons.element} wrapper="span" />
            </div>
            <div className="title">{t('element')}</div>
          </Menu.Item>
        ),
        pane: (
          <Tab.Pane key="element">
            <TabPane
              type="Element"
              userId={user.userId}
              searchEnable={true}
              loadMoreResource={loadMoreResource}
              handleResourceClicked={handleResourceClicked}
              customInfiniteScroller={customInfiniteScroller}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: replaceEntity ? null : (
          <Menu.Item key="text">
            <div className="icon">
              <ReactSVG src={icons.text} wrapper="span" />
            </div>
            <div className="title">{t('text')}</div>
          </Menu.Item>
        ),
        pane: (
          <Tab.Pane key="text">
            <TabPane
              type="Text"
              userId={user.userId}
              searchEnable={true}
              loadMoreResource={loadMoreResource}
              handleResourceClicked={handleResourceClicked}
              customInfiniteScroller={customInfiniteScroller}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: (
          <Menu.Item key="video">
            <div className="icon">
              <ReactSVG src={icons.video} wrapper="span" />
            </div>
            <div className="title">{t('video')}</div>
          </Menu.Item>
        ),
        pane: (
          <Tab.Pane key="video">
            <TabPane
              type="Video"
              userId={user.userId}
              searchEnable={true}
              loadMoreResource={loadMoreResource}
              handleResourceClicked={handleResourceClicked}
              customInfiniteScroller={customInfiniteScroller}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: replaceEntity ? null : (
          <Menu.Item key="background">
            <div className="icon">
              <ReactSVG src={icons.background} wrapper="span" />
            </div>
            <div className="title">{t('background')}</div>
          </Menu.Item>
        ),
        pane: (
          <Tab.Pane key="background" className="backgroundsPane">
            <TabPane
              type="Background"
              userId={user.userId}
              searchEnable={true}
              loadMoreResource={loadMoreResource}
              handleResourceClicked={handleResourceClicked}
              customInfiniteScroller={customInfiniteScroller}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: (
          <Menu.Item key="upload">
            <div className="icon">
              <ReactSVG src={icons.upload} wrapper="span" />
            </div>
            <div className="title">{t('upload')}</div>
          </Menu.Item>
        ),
        pane: (
          <Tab.Pane key="upload">
            <Button
              fluid
              className="vButton colorPrimary"
              content={t('uploadPictureVideo')}
              onClick={() => fileInputRef.current.click()}
            />
            <input
              ref={fileInputRef}
              type="file"
              accept="image/heic,image/heif,image/jpeg,image/png,image/svg+xml,video/mp4,video/quicktime,image/gif"
              hidden
              onChange={fileChange}
            />
            <Tab
              id="uploadTab"
              menu={{ fluid: true }}
              activeIndex={uploadTabActiveIndex}
              panes={uploadPanes.current}
              renderActiveOnly={false}
              onTabChange={(e, { activeIndex }) => setUploadTabActiveIndex(activeIndex)}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: replaceEntity ? null : (
          <Menu.Item key="folder">
            <div className="icon">
              <ReactSVG src={icons.folder} wrapper="span" />
            </div>
            <div className="title">{t('folder')}</div>
          </Menu.Item>
        ),
        pane: {
          key: 'folder',
          content: (
            <div className="folders">
              <Header content={t('folders')} />
              <List selection verticalAlign="middle">
                {userFolders.map((folder, index) => (
                  <List.Item key={index} className="with-settings" onClick={() => handleUserFolderClick(folder)}>
                    <span className="item-image">
                      <Icon name="folder" size="large" />
                    </span>
                    <List.Content>
                      <List.Header>{folder.name === '__Liked__' ? t('liked') : folder.name}</List.Header>
                    </List.Content>
                    {folder.name !== '__Liked__' && (
                      <Icon
                        name="close"
                        className="button-more"
                        title={t('deleteFolder')}
                        onClick={() => {
                          selectedFolderRef.current = folder.id;
                          setOpenConfirm(true);
                        }}
                      />
                    )}
                  </List.Item>
                ))}
                <List.Item onClick={() => setOpenCreateFolder(true)}>
                  <span className="item-image dots-border">
                    <Icon name="add" size="large" />
                  </span>
                  <List.Content>
                    <List.Header>{t('createFolder')}</List.Header>
                  </List.Content>
                </List.Item>
              </List>
            </div>
          ),
        },
      },
      // {
      //   menuItem: replaceEntity ? null : (
      //     <Menu.Item key="more">
      //       <div className="icon">
      //         <ReactSVG src={icons.more} wrapper="span" />
      //       </div>
      //       <div className="title">{t('more')}</div>
      //     </Menu.Item>
      //   ),
      //   pane: {
      //     key: 'more',
      //     content: <div />,
      //   },
      // },
      ...Object.values(openFolders),
    ];

    const smartAssistantPane = {
      menuItem: replaceEntity ? null : (
        <Menu.Item key="smart-assistant">
          <div className="icon"><Icon name="magic" size="large" /></div>
          <div className="title">{t('smartAssistant')}</div>
        </Menu.Item>
      ),
      pane: (
        <Tab.Pane key="smart-assistant">
          <Segment basic textAlign="center" className="smartAssistantPane">
            <Icon name="magic" size="huge" />
            <Header as="h3">{t('smartAssistant')}</Header>
            <p>{t('smartAssistantPending')}</p>
          </Segment>
        </Tab.Pane>
      ),
    };
    const lessonResourcePhotos = lessonResources.map((resource, index) => {
      const thumbnailText = resource.type === 'Video' ? 'frame' : 'thumbnail';
      const resourceName = resource.type === 'Text' ? resource._id : resource.name;
      const width = Number(resource.width) > 0 ? Number(resource.width) : 1;
      const height = Number(resource.height) > 0 ? Number(resource.height) : 1;
      const srcThumbnail = generateImageLink(
        `${process.env.REACT_APP_FILE_SERVER}/resources/${String(resource.type).toLowerCase()}s/${resourceName}/${thumbnailText}.${resource.extension}`,
        authToken,
      );
      return {
        src: srcThumbnail,
        width,
        height,
        key: `${resource._id}-${index}`,
        type: resource.type,
        data: {
          id: resource._id,
          src: srcThumbnail.replace(thumbnailText, 'screen'),
          srcThumbnail,
          name: resource.name,
          extension: resource.extension,
          width,
          height,
          tags: resource.tags,
          price: resource.price,
          ...resource.data,
        },
      };
    });
    const lessonResourcesPane = {
      menuItem: replaceEntity ? null : (
        <Menu.Item key="lesson-resources">
          <div className="icon"><Icon name="puzzle piece" size="large" /></div>
          <div className="title">منابع این درس</div>
        </Menu.Item>
      ),
      pane: (
        <Tab.Pane key="lesson-resources">
          <Header as="h3">منابع آماده این درس</Header>
          {lessonResourcesLoading && <Segment basic loading style={{ minHeight: 120 }} />}
          {!lessonResourcesLoading && !lessonTemplateId && <p>ابتدا یک درس یا قالب آموزشی را انتخاب کنید.</p>}
          {!lessonResourcesLoading && lessonTemplateId && lessonResourcePhotos.length === 0 && <p>برای این درس هنوز منبعی ثبت نشده است.</p>}
          {!lessonResourcesLoading && lessonResourcePhotos.length > 0 && (
            <Gallery
              photos={lessonResourcePhotos}
              targetRowHeight={90}
              renderImage={args => customRenderImage(args, args.photo.type)}
            />
          )}
        </Tab.Pane>
      ),
    };
    const lessonVideoPane = {
      menuItem: replaceEntity ? null : (
        <Menu.Item key="lesson-video" className="lessonVideoMenuItem">
          <div className="icon"><Icon name="play circle outline" size="large" /></div>
          <div className="title">ویدئوی درس</div>
        </Menu.Item>
      ),
      pane: (
        <Tab.Pane key="lesson-video">
          <Header as="h3">راهنمای کوتاه درس</Header>
          {!lessonTemplateId && <p>ابتدا یک درس یا قالب آموزشی را انتخاب کنید.</p>}
          {lessonTemplateId && !_.get(lessonTemplate, 'tutorialVideo') && <p>برای این درس هنوز ویدیوی آموزشی ثبت نشده است.</p>}
          {lessonTemplateId && _.get(lessonTemplate, 'tutorialVideo') && (
            <Button fluid icon="play circle" content="پخش ویدئوی آموزشی" onClick={() => setTutorialVideoTemplate({ ...lessonTemplate, id: lessonTemplate._id })} />
          )}
        </Tab.Pane>
      ),
    };
    const educationPanes = [
      tempPanes[0],
      tempPanes[1],
      tempPanes[2],
      tempPanes[3],
      smartAssistantPane,
      tempPanes[6],
      tempPanes[7],
      lessonResourcesPane,
      ...tempPanes.slice(8),
      lessonVideoPane,
    ];

    if (_type === 'text') setPanes([tempPanes[3]]);
    else setPanes(educationPanes);

    if (openFolderRef.current) {
      setActiveIndex(9 + openFolderRef.current - 1);
      openFolderRef.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    templates,
    userImages,
    userVideos,
    userFolders,
    replaceEntity,
    openFolders,
    uploading,
    uploadProgress,
    uploadTabActiveIndex,
    showTemplatePages,
    lessonResources,
    lessonResourcesLoading,
    lessonTemplate,
    lessonTemplateId,
  ]);

  useEffect(() => {
    if (replaceEntity) {
      if (initResources.current[1]) loadMoreResource('Image', true);
      initResources.current[1] = false;
      setActiveIndex(1);
      setHideMenu(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [replaceEntity]);

  useEffect(() => {
    if (folderState === 'createFailed') {
      formikCreateFolder.setFieldError('name', t('yupCreateFolderFailed'));
    } else if (folderState === 'created') {
      setOpenCreateFolder(false);
    } else if (folderState === 'added') {
      notify(t('addToFolder200'));
    } else if (folderState === 'deleted') {
      notify(t('deleteFolder200'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folderState]);

  const handleRangeChange = () => {
    setActiveIndex(-1);
    setHideMenu(1);
  };

  const handleTabChange = (e, x) => {
    toolsCloseHandler();
    const { activeIndex } = x;
    switch (activeIndex) {
      case 0:
        if (initResources.current[activeIndex]) loadMoreResource('Template', true);
        initResources.current[activeIndex] = false;
        break;
      case 1:
        if (initResources.current[activeIndex]) loadMoreResource('Image', true);
        initResources.current[activeIndex] = false;
        break;
      case 2:
        if (initResources.current[activeIndex]) loadMoreResource('Element', true, { grouped: true });
        initResources.current[activeIndex] = false;
        break;
      case 3:
        if (initResources.current[activeIndex]) loadMoreResource('Text', true, { grouped: true });
        initResources.current[activeIndex] = false;
        break;
      case 4:
        // Smart assistant shell; behavior will be connected after its workflow is approved.
        break;
      case 5:
        if (userImages.length === 0) loadMoreResource('UserImage', true);
        if (userVideos.length === 0) loadMoreResource('UserVideo', true);
        break;
      case 6:
        if (initResources.current[activeIndex]) dispatch(resourceActions.getUserFolders());
        initResources.current[activeIndex] = false;
        break;
      default:
        break;
    }
    setActiveIndex(activeIndex);
    setHideMenu(0);
  };

  const handleSearchChange = (event, { value }) => {
    if (value.length === 0) {
      closeIconRef.current.style.display = 'none';
    } else {
      closeIconRef.current.style.display = 'block';
    }
  };

  const handleSearchKeyPress = event => {
    if (event.key === 'Enter' || event.target.title === 'searchIcon') {
      if (!_.isEmpty(templateInputRef.current.value)) {
        templateScrollPaneRef.current.className = 'scroller-pan searched-content';
        returnButtonRef.current.ref.current.className = 'searchResetBtn active';
      }
      loadMoreResource('Template', true);
    }
  };

  const handleSearchClearClicked = event => {
    templateScrollPaneRef.current.className = 'scroller-pan';
    returnButtonRef.current.ref.current.className = 'searchResetBtn';
    templateInputRef.current.value = '';
    closeIconRef.current.style.display = 'none';
    loadMoreResource(event.target.title, true);
  };

  const handleResourceClicked = resource => {
    switch (resource.type) {
      case 'Template':
      case 'TemplatePage':
        // Block action if template has price and user hadn't subscription
        if (user.role === 'client' && resource.data.price > 0 && !hasSubscription) {
          setActiveDim(true);
          return;
        }
        dispatch(templateActions.selectTemplate(resource.data.templateId || resource.data.id));
        // If operator select template should reset design to edit template
        if (isOperationalUser) {
          dispatch(designActions.loadTemplateDesign(activePageRef.current, resource.data, true));

          tempId.current = resource.data.tempId;
          loadMoreResource('Image', true);
          loadMoreResource('Element', true);
          loadMoreResource('Video', true);
          initResources.current[1] = false;
          initResources.current[2] = false;
        } else {
          if (_.get(resource, 'data.pages', []).length > 1 && !showTemplatePages) {
            selectedTemplateRef.current = resource;
            templatePagesRef.current = [];
            for (let i = 0; i < _.get(resource, 'data.pages', []).length; i++) {
              templatePagesRef.current.push({
                src: `${process.env.REACT_APP_FILE_SERVER}/resources/templates/${resource.data.id}-${i +
                  1}/thumbnail.png`,
                width: resource.width,
                height: resource.height,
                type: 'TemplatePage',
                name: resource.data.name,
                data: {
                  id: `${resource.data.id}-${i}`,
                  templateId: resource.data.id,
                  name: resource.data.name,
                  pages: [{ ...resource.data.pages[i] }],
                  size: resource.data.size,
                },
              });
            }
            setShowTemplatePages(true);
          } else {
            dispatch(designActions.loadTemplateDesign(activePageRef.current, resource.data, false));
          }
        }
        break;
      case 'Background':
        dispatch(
          designActions.changeEntity(
            activePageRef.current,
            'Background',
            resource.data.id,
            resource.data.src,
            // The background is fixed component and must use known media
            // so changed "resource.type" to "Image"
            'Image',
          ),
        );
        break;
      default:
        if (replaceEntity) {
          dispatch(
            designActions.changeEntity(activePageRef.current, selectedEntity.id, resource.data.src, resource.type),
          );
          dispatch(designActions.changeReplaceEntityState(false));
          setActiveIndex(-1);
          setHideMenu(1);
        } else {
          addEntityToDesign(resource);
        }
        break;
    }

    if (isMobileOnly) {
      setActiveIndex(-1);
      setHideMenu(1);
    }
  };

  const addEntityToDesign = item => {
    const keyId = window.$_getEntityKey();
    const { droppedWidth, droppedHeight, droppedScale } = calculateDroppedEntitySize(
      designWidthRef.current,
      designHeightRef.current,
      item.data.width,
      item.data.height,
    );
    const translateX = designWidthRef.current / 2 - droppedWidth / 2;
    const translateY = designHeightRef.current / 2 - droppedHeight / 2;

    const style = {
      master: {
        transform: `translateX(${translateX ? translateX : 0}px) translateY(${translateY ? translateY : 0
          }px) rotate(0deg) scaleX(1) scaleY(1)`,
      },
      inner: { width: droppedWidth, height: droppedHeight },
    };

    var entity;
    switch (item.type) {
      case 'Image':
        entity = {
          type: item.type,
          keyId,
          style,
          src: item.data.src,
          resource: item.data.id,
        };
        break;
      case 'Video':
        style.master = { ...style.master, height: style.inner.height, width: style.inner.width };
        entity = {
          type: item.type,
          keyId,
          style,
          src: item.data.src,
          resource: item.data.id,
        };
        break;
      case 'Text':
        console.log(item);
        // eslint-disable-next-line no-case-declarations
        const newTranslateX = designWidthRef.current / 2 - droppedWidth / droppedScale / 2;
        // eslint-disable-next-line no-case-declarations
        const newTranslateY = designHeightRef.current / 2 - droppedHeight / droppedScale / 2;
        style.master.transform = `translateX(${newTranslateX}px) translateY(${newTranslateY}px) rotate(0deg) scaleX(${droppedScale /
          2}) scaleY(${droppedScale / 2})`;
        style.inner = {};

        if (item.data.entities) dispatch(designActions.loadTextDesign(activePageRef.current, item.data.entities));
        else {
          dispatch(designActions.addNewEditorState({ id: keyId, contentType: 'html', ...item.data }));

          entity = {
            type: item.type,
            keyId,
            style,
          };
        }
        break;
      case 'Shape':
        dispatch(designActions.addNewSVGState({ id: keyId, data: [] }));
        entity = {
          type: item.type,
          keyId,
          style,
          src: item.data.src,
          resource: item.data.id,
        };
        break;
      case 'Vector':
        dispatch(designActions.addNewSVGState({ id: keyId, data: [] }));
        entity = {
          type: item.type,
          keyId,
          style,
          src: item.data.src,
          resource: item.data.id,
        };
        break;
      case 'Frame':
        dispatch(designActions.addNewSVGState({ id: keyId, data: [] }));
        entity = {
          type: item.type,
          keyId,
          style,
          data: item.data,
          resource: item.data.id,
        };
        break;
      case 'Grid':
        entity = {
          type: item.type,
          keyId,
          style,
          data: item.data,
          resource: item.data.id,
        };
        break;
      case 'Line':
        entity = {
          type: item.type,
          keyId,
          style,
          src: item.data.src,
          data: {},
          resource: item.data.id,
        };
        break;
      default:
        break;
    }
    entity &&
      dispatch(
        designActions.addEntity(activePageRef.current, {
          entities: [{ id: keyId, type: item.type }],
          states: { [keyId]: entity },
        }),
      );
  };

  const fileChange = event => {
    if (event.target.files[0].type.includes('image')) {
      userImageList.current.push({
        src: `${process.env.REACT_APP_FILE_SERVER}/users/${user.userId}/resources/uploading/thumbnail.png`,
        width: 150,
        height: 150,
        key: 'unknown',
        type: 'Uploading',
        data: {
          id: 'unknown',
        },
      });
      setUploadTabActiveIndex(0);
    } else {
      userVideoList.current.push({
        src: `${process.env.REACT_APP_FILE_SERVER}/users/${user.userId}/resources/uploading/thumbnail.png`,
        width: 150,
        height: 150,
        key: 'unknown',
        type: 'Uploading',
        data: {
          id: 'unknown',
        },
      });
      setUploadTabActiveIndex(1);
    }

    dispatch(resourceActions.upload([...event.target.files]));
  };

  const downloadResource = (name, resourceLink) => {
    const re = /(?:\.([^.]+))?$/;
    const filenameWithExtension = resourceLink.substring(resourceLink.lastIndexOf('/') + 1);
    const extension = re.exec(filenameWithExtension)[1];

    if (browserName === 'Chrome' || browserName === 'Chromium') {
      fetch(resourceLink, { credentials: 'include' }).then(response => {
        response.blob().then(blob => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = `${name}.${extension}`;
          a.click();
        });
      });
    } else {
      let link = document.createElement('a');
      link.href = resourceLink;
      link.download = `${name}.${extension}`;
      link.click();
    }
  };

  // eslint-disable-next-line no-unused-vars
  const customRenderImage = ({ index, left, top, key, photo }, type) => {
    const imgStyle = {
      transition: 'transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s',
    };
    const cont = {
      marginTop: '-2px',
      cursor: 'pointer',
      position: 'relative',
    };
    const image = (
      <img
        id={photo.data.id}
        alt={photo.title}
        style={{ ...imgStyle }}
        loading="lazy"
        {...photo}
        onClick={() => handleResourceClicked(photo)}
      />
    );
    let draggableContent;
    const srcSet = [photo.src];

    if (photo.data) photo.data.scale = photo.data.width / photo.width;
    if (photo.type === 'Uploading') {
      draggableContent = (
        <div className="with-progress">
          {image}
          <Progress percent={uploadProgress} size="tiny" indicating />
        </div>
      );
    } else if (type === 'UserImage' || type === 'UserVideo') {
      const settingsContentRef = React.createRef();
      const foldersContentRef = React.createRef();
      const folders = [];
      userFoldersRef.current.forEach((folder, index) => {
        if (folder.name !== '__Liked__')
          folders.push(
            <Item key={index} onClick={() => dispatch(resourceActions.addToFolder(folder.id, photo))}>
              <Item.Image size="tiny" src="https://react.semantic-ui.com/images/wireframe/image.png" />
              <Item.Content verticalAlign="middle">{folder.name}</Item.Content>
            </Item>,
          );
      });
      const showFolders = () => {
        if (initResources.current[6]) dispatch(resourceActions.getUserFolders());
        initResources.current[6] = false;

        settingsContentRef.current.hidden = true;
        foldersContentRef.current.hidden = false;
      };

      draggableContent = (
        <div className="with-settings">
          {image}
          <div className="button-more">
            <Popup className="popup" on="click" basic trigger={<Button icon="ellipsis horizontal" />}>
              <Popup.Content>
                <span ref={foldersContentRef} hidden={true}>
                  <Grid>
                    <Grid.Column floated="right">
                      <span className="title">{t('addToFolder')}</span>
                    </Grid.Column>
                  </Grid>
                  <Divider />
                  <Item.Group link>{folders}</Item.Group>
                </span>
                <span ref={settingsContentRef}>
                  <Grid>
                    <Grid.Column floated="right">{photo.data.alias}</Grid.Column>
                  </Grid>
                  <Divider />
                  <List relaxed verticalAlign="middle">
                    <List.Item as="a" onClick={() => showFolders(settingsContentRef, foldersContentRef)}>
                      <List.Icon name="folder outline" />
                      <List.Content>
                        <List.Header content={t('moveToFolder')} />
                      </List.Content>
                    </List.Item>
                    <List.Item as="a" onClick={() => downloadResource(photo.data.alias, photo.data.src)}>
                      <List.Icon name="download" />
                      <List.Content>
                        <List.Header content={t('downloadOrigin')} />
                      </List.Content>
                    </List.Item>
                    <List.Item as="a" onClick={() => dispatch(resourceActions.deleteResource(type, photo.data.id))}>
                      <List.Icon name="trash alternate outline" />
                      <List.Content>
                        <List.Header content={t('delete')} />
                      </List.Content>
                    </List.Item>
                  </List>
                </span>
              </Popup.Content>
            </Popup>
          </div>
          <div className="design-checked">
            <Checkbox />
          </div>
        </div>
      );
    } else if (type === 'Template') {
      for (let i = 1; i < _.get(photo, 'data.pages', []).length; i++) {
        srcSet.push(`${process.env.REACT_APP_FILE_SERVER}/resources/templates/${photo.data.id}-${i + 1}/thumbnail.png`);
      }
      draggableContent = (
        <div className="with-settings">
          {_.get(photo, 'data.price', 0) > 0 && <span className="proMark"></span>}
          <SlideShow
            id={photo.data.id}
            alt={photo.title}
            style={{ ...imgStyle }}
            {...photo}
            onClick={() => handleResourceClicked(photo)}
            srcSet={srcSet}
          />
          <div className="button-more">
            <Popup className="popup" on="click" basic trigger={<Button icon="ellipsis horizontal" />}>
              <Popup.Content>
                <Grid>
                  <Grid.Column floated="right">
                    <Header content={photo.data.name} />
                  </Grid.Column>
                </Grid>
                <Divider />
                <Grid>
                  <Grid.Column floated="right">
                    <span className="title">{t('keywords')}:</span>
                    {Array.isArray(_.get(photo, 'data.tags', []))
                      ? _.get(photo, 'data.tags', []).join(', ')
                      : photo.data.tags}
                  </Grid.Column>
                </Grid>
                {photo.data.tutorialVideo && (
                  <>
                    <Divider />
                    <Button
                      fluid
                      icon="play circle"
                      content={t('watchLessonVideo')}
                      onClick={() => setTutorialVideoTemplate(photo.data)}
                    />
                  </>
                )}
              </Popup.Content>
            </Popup>
          </div>
        </div>
      );
    } else if (type === 'TemplatePage') {
      draggableContent = image;
    } else if (type === 'Image' || type === 'Video' || type === 'Element' || type === 'Background') {
      const settingsContentRef = React.createRef();
      const foldersContentRef = React.createRef();
      const folders = [];
      userFoldersRef.current.forEach((folder, index) => {
        if (folder.name !== '__Liked__')
          folders.push(
            <Item key={index} onClick={() => dispatch(resourceActions.addToFolder(folder.id, photo))}>
              <Item.Image size="tiny" src="https://react.semantic-ui.com/images/wireframe/image.png" />
              <Item.Content verticalAlign="middle">{folder.name}</Item.Content>
            </Item>,
          );
      });
      const showFolders = () => {
        if (initResources.current[6]) dispatch(resourceActions.getUserFolders());
        initResources.current[6] = false;

        settingsContentRef.current.hidden = true;
        foldersContentRef.current.hidden = false;
      };

      draggableContent = (
        <div className="with-settings">
          {_.get(photo, 'data.price', 0) > 0 && <span className="proMark"></span>}
          {image}
          <div className="button-more">
            <Popup className="popup" on="click" basic trigger={<Button icon="ellipsis horizontal" />}>
              <Popup.Content>
                <span ref={foldersContentRef} hidden={true}>
                  <Grid>
                    <Grid.Column floated="right">
                      <span className="title">{t('addToFolder')}</span>
                    </Grid.Column>
                  </Grid>
                  <Divider />
                  <Item.Group link>{folders}</Item.Group>
                </span>
                <span ref={settingsContentRef}>
                  <Grid>
                    <Grid.Column floated="right">
                      <span className="title">{t('keywords')}:</span>
                      {Array.isArray(_.get(photo, 'data.tags', []))
                        ? _.get(photo, 'data.tags', []).join(', ')
                        : photo.data.tags}
                    </Grid.Column>
                  </Grid>
                  <Divider />
                  <List relaxed verticalAlign="middle">
                    <List.Item
                      as="a"
                      onClick={() =>
                        dispatch(resourceActions.userAction(type, photo.data.id, photo.data.liked ? 'unlike' : 'like'))
                      }
                    >
                      <List.Icon name="heart outline" />
                      <List.Content>
                        <List.Header content={photo.data.liked ? t('removeLike') : t('addLike')} />
                      </List.Content>
                    </List.Item>
                    <List.Item as="a" onClick={() => showFolders(settingsContentRef, foldersContentRef)}>
                      <List.Icon name="folder outline" />
                      <List.Content>
                        <List.Header content={t('addToFolder')} />
                      </List.Content>
                    </List.Item>
                  </List>
                </span>
              </Popup.Content>
            </Popup>
          </div>
          {type === 'Video' ? (
            <span className="videoDuration">
              {new Date(_.get(photo, 'data.duration', 0) * 1000).toISOString().substr(14, 5)}
            </span>
          ) : null}
        </div>
      );
    } else {
      const settingsContentRef = React.createRef();
      const foldersContentRef = React.createRef();
      const folders = [];
      userFoldersRef.current.forEach((folder, index) => {
        if (folder.name !== '__Liked__')
          folders.push(
            <Item key={index} onClick={() => dispatch(resourceActions.addToFolder(folder.id, photo))}>
              <Item.Image size="tiny" src="https://react.semantic-ui.com/images/wireframe/image.png" />
              <Item.Content verticalAlign="middle">{folder.name}</Item.Content>
            </Item>,
          );
      });
      const showFolders = () => {
        if (initResources.current[6]) dispatch(resourceActions.getUserFolders());
        initResources.current[6] = false;

        settingsContentRef.current.hidden = true;
        foldersContentRef.current.hidden = false;
      };
      draggableContent = (
        <div className="with-settings">
          {image}
          <div className="button-more">
            <Popup className="popup" on="click" basic trigger={<Button icon="ellipsis horizontal" />}>
              <Popup.Content>
                <span ref={foldersContentRef} hidden={true}>
                  <Grid>
                    <Grid.Column floated="right">
                      <span className="title">{t('addToFolder')}</span>
                    </Grid.Column>
                  </Grid>
                  <Divider />
                  <Item.Group link>{folders}</Item.Group>
                </span>
                <span ref={settingsContentRef}>
                  <Grid>
                    <Grid.Column floated="right">
                      <span className="title">{t('keywords')}:</span>
                      {Array.isArray(_.get(photo, 'data.tags', []))
                        ? _.get(photo, 'data.tags', []).join(', ')
                        : photo.data.tags}
                    </Grid.Column>
                  </Grid>
                  <Divider />
                  <List relaxed verticalAlign="middle">
                    <List.Item
                      as="a"
                      onClick={() =>
                        dispatch(resourceActions.userAction(type, photo.data.id, photo.data.liked ? 'unlike' : 'like'))
                      }
                    >
                      <List.Icon name="heart outline" />
                      <List.Content>
                        <List.Header content={photo.data.liked ? t('removeLike') : t('addLike')} />
                      </List.Content>
                    </List.Item>
                    <List.Item as="a" onClick={() => showFolders(settingsContentRef, foldersContentRef)}>
                      <List.Icon name="folder outline" />
                      <List.Content>
                        <List.Header content={t('addToFolder')} />
                      </List.Content>
                    </List.Item>
                    <List.Item
                      as="a"
                      onClick={() => dispatch(resourceActions.removeFromFolder(type, photo.data.id, index))}
                    >
                      <List.Icon name="close" />
                      <List.Content>
                        <List.Header content={t('removeFromFolder')} />
                      </List.Content>
                    </List.Item>
                  </List>
                </span>
              </Popup.Content>
            </Popup>
          </div>
        </div>
      );
    }
    return (
      <Draggable key={index} data={photo.data} type={photo.type} style={{ margin: '2px', ...cont }}>
        {draggableContent}
      </Draggable>
    );
  };

  customRenderImage.propTypes = {
    photo: PropTypes.object,
    key: PropTypes.any,
    top: PropTypes.number,
    left: PropTypes.number,
    index: PropTypes.number,
  };

  const customInfiniteScroller = ({
    hasMore,
    type,
    photos = [],
    searchByTag,
    scrollParentRef,
    searchInputRef,
    loading,
  }) => {
    const grouped = photos && photos[0] && (photos[0].resources || photos[0].templates || photos[0].props);
    let height;
    switch (type) {
      case 'Video':
        height = 110;
        break;
      case 'Template':
        height = 148;
        break;
      default:
        height = 50;
        break;
    }
    let innerPhotos;
    if (grouped) {
      innerPhotos = [];
      photos.forEach((resourceGroup, index) => {
        innerPhotos.push(
          <HorizontalCards
            key={index}
            className={type === 'Template' ? 'horizontalScroll _template' : 'horizontalScroll'}
            userId={user.userId}
            parent="VSidebar"
            title={t(`tags:${resourceGroup._id}`)}
            showMore={t('showMore')}
            items={type === 'Template' ? resourceGroup.templates : resourceGroup.resources}
            itemType={type}
            customImage={customRenderImage}
            height={height}
            width={type === 'Template' ? undefined : 306}
            onTitleClick={() => searchByTag(resourceGroup._id)}
            onShowMoreClick={() => searchByTag(resourceGroup._id)}
            arrowLeft={
              <div className="_arrow right-arrow">
                <Icon name="angle right" />
              </div>
            }
            arrowRight={
              <div className="_arrow left-arrow">
                <Icon name="angle left" />
              </div>
            }
          />,
        );
      });
    } else {
      innerPhotos = (
        <Gallery
          photos={photos || []}
          targetRowHeight={type === 'Element' ? 50 : 100}
          limitNodeSearch={type === 'Element' ? 3 : undefined}
          renderImage={args => customRenderImage(args, type)}
        />
      );
    }

    return (
      <InfiniteScroller
        pageStart={0}
        threshold={100}
        initialLoad={false}
        hasMore={hasMore}
        loadMore={() => {
          loading !== 'loading' && loadMoreResource(type, false, { q: _.get(searchInputRef, 'current.value', '') });
        }}
        useWindow={false}
        getScrollParent={() => scrollParentRef.current}
      >
        {innerPhotos}
        {(photos.length === 0 && type !== "Text") && <span>{t('nothingToShow')}</span>}
      </InfiniteScroller>
    );
  };

  customInfiniteScroller.propTypes = {
    hasMore: PropTypes.bool,
    type: PropTypes.string,
    photos: PropTypes.array,
    searchByTag: PropTypes.func,
    scrollParentRef: PropTypes.any,
    searchInputRef: PropTypes.any,
    loading: PropTypes.string,
  };

  /**
   *
   * @param {*} type Template|Image|Element|Video|UserImage|UserVideo
   * @param {*} clear
   * @param {*} query value of search box
   */
  const loadMoreResource = (type, clear, query = {}) => {
    switch (type) {
      case 'Template':
        if (_.get(templateInputRef, 'current.value', '').length > 0) {
          if (isOperationalUser) {
            query.name = templateInputRef.current.value;
          } else {
            query.q = templateInputRef.current.value;
            query.categories = selectedTemplateCategory;
          }
        } else {
          query.groupBy = 'categories';
          query.perGroupLimit = 15;
          query.categories = selectedTemplateCategory;
        }
        dispatch(templateActions.search(query, clear));
        break;
      case 'UserImage':
        dispatch(resourceActions.getUserResource('Image'));
        break;
      case 'UserVideo':
        dispatch(resourceActions.getUserResource('Video'));
        break;
      case 'Element':
      case 'Video':
        if (_.get(query, 'q', '').length === 0 && !tempId.current) query.grouped = true;
        if (type === 'Element') query.educationOnly = true;
        dispatch(resourceActions.search({ type, ...query, tempId: tempId.current, extra: true }, clear));
        break;
      case 'Text':
      case 'Image':
      case 'Background':
        dispatch(resourceActions.search({ type, ...query, tempId: tempId.current, extra: true }, clear));
        break;
      default:
        dispatch(resourceActions.getFolderResources(type, clear));
        break;
    }
  };

  const handleUserFolderClick = folder => {
    const newOpenFolders = {
      ...openFolders,
      [folder.id]: {
        menuItem: (
          <Menu.Item key={folder.id}>
            <div className="icon">
              <ReactSVG src={icons.folder} wrapper="span" />
            </div>
            <div className="title">{folder.name === '__Liked__' ? t('liked') : folder.name}</div>
          </Menu.Item>
        ),
        pane: (
          <Tab.Pane key={folder.id}>
            <TabPane
              type={folder.id}
              userId={user.userId}
              searchEnable={false}
              loadMoreResource={loadMoreResource}
              handleResourceClicked={handleResourceClicked}
              customInfiniteScroller={customInfiniteScroller}
            />
          </Tab.Pane>
        ),
      },
    };
    setOpenFolders(newOpenFolders);
    loadMoreResource(folder.id, true);
    openFolderRef.current = Object.keys(newOpenFolders).indexOf(folder.id) + 1;
  };

  const deleteFolder = () => {
    const newOpenFolders = { ...openFolders };
    delete newOpenFolders[selectedFolderRef.current];
    setOpenFolders(newOpenFolders);
    setActiveIndex(6);
    dispatch(resourceActions.deleteFolder(selectedFolderRef.current));
    setOpenConfirm(false);
  };

  const toolsOpenHandler = () => {
    document.getElementById('GBTools').classList.add('toolsPanel');
    document.getElementById('toolsCover').classList.add('active');
  };

  const toolsCloseHandler = () => {
    document.getElementById('toolsCover').classList.remove('active');
    document.getElementById('GBTools').classList.remove('toolsPanel');
  };

  return (
    <div id="toolsContainer">
      <div id="toolsCover" onMouseDown={toolsCloseHandler}></div>
      {/* Just for mobile */}
      <div id="toolsMobileOpener" onMouseDown={toolsOpenHandler}>
        +
      </div>
      {!hideMenu && (
        <div id="toolsClosePanel" onMouseDown={handleRangeChange}>
          +
        </div>
      )}
      {/* Just for mobile END */}
      <Tab
        id="GBTools"
        menu={{ fluid: true, vertical: true }}
        panes={panes}
        activeIndex={activeIndex}
        renderActiveOnly={false}
        onTabChange={handleTabChange}
      />
      <div className={'detailCloseHandler ' + (hideMenu ? 'hide' : '')} onClick={handleRangeChange}>
        <SvgCloseSlid className="closeSlid" />
      </div>
      <Modal
        className="modalCreateFolder"
        dimmer="blurring"
        size="tiny"
        open={openCreateFolder}
        onClose={() => setOpenCreateFolder(false)}
      >
        <Modal.Header>{t('createFolder')}</Modal.Header>
        <Modal.Content>
          <Form size="large" onKeyDown={e => e.key === 'Enter' && formikCreateFolder.handleSubmit()}>
            <Segment basic>
              <Form.Input
                label={t('folderName')}
                error={formikCreateFolder.touched.name ? formikCreateFolder.errors.name : null}
                disabled={folderState === 'creating'}
                fluid
                placeholder={t('folderName')}
                name="name"
                value={formikCreateFolder.values.name}
                onChange={formikCreateFolder.handleChange}
              />
            </Segment>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content={t('createFolder')}
            loading={folderState === 'creating'}
            onClick={formikCreateFolder.handleSubmit}
          />
        </Modal.Actions>
      </Modal>
      <Confirm
        open={openConfirm}
        size="mini"
        confirmButton={t('ok')}
        cancelButton={t('cancel')}
        content={t('confirmDeleteFolder')}
        onCancel={() => setOpenConfirm(false)}
        onConfirm={deleteFolder}
      />
      <Modal
        size="small"
        open={Boolean(tutorialVideoTemplate)}
        onClose={() => setTutorialVideoTemplate(null)}
      >
        <Modal.Header>{tutorialVideoTemplate ? tutorialVideoTemplate.name : t('lessonVideo')}</Modal.Header>
        <Modal.Content>
          {tutorialVideoTemplate && (
            <video
              controls
              autoPlay
              preload="metadata"
              style={{ display: 'block', width: '100%', maxHeight: '70vh' }}
              src={generateImageLink(
                `${process.env.REACT_APP_FILE_SERVER}/templates/${tutorialVideoTemplate.id}/tutorial-video`,
                authToken,
              )}
            >
              {t('videoNotSupported')}
            </video>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button content={t('close')} onClick={() => setTutorialVideoTemplate(null)} />
        </Modal.Actions>
      </Modal>
      <Dimmer active={activeDim} blurring="true" className="attentionAlert">
        <Header as="h2" icon>
          {t('noSubscription')}
          <br />
        </Header>
        <div className="dimContent">
          <Button className="vButton colorPrimary" content={t('gotIt')} onClick={() => setActiveDim(false)} />
        </div>
      </Dimmer>
    </div>
  );
};

Tools.propTypes = {
  upload: PropTypes.func,
};

export default Tools;
